import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOnHandEntry, IOnHand } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const UpdateOnHandEntryAPI = async (params: IOnHandEntry, osdNumber?: number | string): Promise<IOnHand> => {
  try {
    const response = await axios.put(`${getUrl(ApiType.ON_HAND_ENTRY_CREATE)}/${osdNumber}`, params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.updateOnHandEntry, { badRequestOrder: "errorsFirst" });
  }
};
